import loadable from '@loadable/component';

export default loadable(
  () => import(/* webpackChunkName: "mega-menu" */ './NavigationMegaMenu'),
  {
    ssr: false,
  }
);
